/**
 * step 1 : validate file
 * step 2 : submit the file
 * User Uploads File and On Success clicks Submit. On Errors, disable Submit button.
 */
import { Button, Space, Steps } from 'antd';

import Loading from '../../Pages/purchase-request/Loading';
import { Layout } from '../Common';
import CustomHeader from '../Common/CustomHeader';
import Uploader2 from '../Common/Uploader2';

/**
 * TwoStepUploader component
 *
 * @component
 * @param {Object} props - Component props
 * @param {string} props.title - The title to be displayed in the uploader
 * @param {string} props.selectedKey - the key selected in menu
 * @param {Function} props.onSubmit - Function to handle submission
 * @param {boolean} props.submitDisabled - If subit button is disabled
 * @param {boolean} props.submitting - Submit button loading status
 * @param {boolean} props.validationStatus - Status of the validation process
 * @param {object} props.uploaderProps - object for uploader
 * @param {boolean} props.loading - loading status of uploader
 * @returns {JSX.Element} The rendered component
 */

// eslint-disable-next-line no-unused-vars
const SingleStepUploader = ({
  submitButtonText,
  title,
  selectionKey,
  onSubmit,
  submitDisabled,
  submitting,
  uploaderProps,
  loading,
  steps,
  currentStep,
  openGroup,
  before
}) => {
  return (
    <Layout openGroup={openGroup ?? ['bulkUploaders']} selected={selectionKey}>
      <div className="create">
        {title ? <CustomHeader title={title} /> : null}
        {currentStep ? (
          <section className="grey-bg-strip">
            <Steps current={currentStep} items={steps} size="small" />
          </section>
        ) : null}
        {before || null}
        {loading ? (
          <Loading />
        ) : (
          <Space direction="vertical" style={{ marginTop: 16 }}>
            <Uploader2 items={uploaderProps.items} message={uploaderProps.message} />
            <Space className="btns-container">
              <Button disabled={submitDisabled} loading={submitting} onClick={onSubmit} type="primary">
                {submitButtonText ?? 'Submit'}
              </Button>
            </Space>
          </Space>
        )}
      </div>
    </Layout>
  );
};

export default SingleStepUploader;
